import { render, staticRenderFns } from "./GeneralWindow.vue?vue&type=template&id=1c819920&scoped=true"
import script from "./GeneralWindow.vue?vue&type=script&lang=js"
export * from "./GeneralWindow.vue?vue&type=script&lang=js"
import style0 from "./GeneralWindow.vue?vue&type=style&index=0&id=1c819920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c819920",
  null
  
)

export default component.exports